<template>
    <li
        class="shortlisted"
        :class="{ selected: selected }"
        @mouseenter="hover"
        @mouseleave="blur"
    >
        <div class="inner">
            <div class="flip-card-inner" :class="{ flipped: showShortlistMenu}">
                <div class="flip-card-front">
                    <a
                        :href="`/location-hire/${listing.address.state.slug.toLowerCase()}/${
                            listing.slug
                        }`"
                        class="flex flex-col h-full"
                    >
                        <div class="image">
                            <img
                                :src="
                                    listing.preferred_thumbnail
                                        ? listing.preferred_thumbnail.url
                                        : listing.thumbnail_url
                                "
                                class="cover"
                                :alt="listing.space_name"
                            />
                            <h4
                                class="wt-md lh-std property-type"
                                v-if="
                                    typeof listing.property_type !== 'undefined' &&
                                    listing.property_type
                                "
                            >
                                {{ listing.property_type.label }}
                            </h4>
                        </div>
                        <div class="description">

                            <template v-if="!$store.getters['user/isLister']">
                                <single-button
                                    :listing="listing"
                                    :selected="selected"
                                    :setShowShortlistMenu="setShowShortlistMenu"
                                    @selected="select"
                                    @deselected="deselect"
                                ></single-button>
                            </template>
                            <h4
                                class="wt-std location"
                                v-if="listing.address_label"
                            >
                                <div class="address-label">{{ listing.address_label }}</div>
                            </h4>
                            <h3 class="title font-castoro">
                                <span class="fg-dark">
                                    {{ listing.space_name }}
                                </span>
                            </h3>
                            <div class="flex price__wrap">
                                <h4
                                    class="wt-md fg-dark font-base price"
                                    v-if="
                                        listing.rate_day &&
                                        !listing.price_on_application
                                    "
                                >
                                    From {{listing.rate_day_formatted_including_booking_fee}} per day
                                </h4>
                                <h4 class="wt-md fg-dark font-base price" v-else>
                                    Price on application
                                </h4>
                                <span class="circle-badge arrow">
                                    <svg xmlns="http://www.w3.org/2000/svg">
                                        <image xlink:href="/images/icons/arrow-right.svg" />
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="flip-card-back" @click.stop.prevent>
                    <ShortlistMenu :setShowShortlistMenu="setShowShortlistMenu" :listing="listing" />
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import SingleButton from "../../shortlists/SingleButton";
import ShortlistMenu from "../../shortlists/ShortlistMenu";

export default {
    components: {
        SingleButton,
        ShortlistMenu,
    },
    props: {
        listing: {
            type: Object,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hovered: false,
            showShortlistMenu: false
        };
    },
    computed: {
        infoWindow() {
            return this.$store.getters["listings/infoWindowById"](
                this.listing.id
            );
        },
        marker() {
            return this.$store.getters["listings/markerById"](this.listing.id);
        },
        showMap() {
            return this.$store.getters["listings/showMap"];
        },
    },
    methods: {
        blur() {
            this.hovered = false;
        },
        deselect() {
            this.$emit("deselected");
        },
        hover() {
            this.hovered = true;

            setTimeout(() => {
                if (this.hovered && this.marker) {
                    google.maps.event.trigger(this.marker, "click");
                }
            }, 500);
        },
        select() {
            this.$emit("selected");
        },
        setShowShortlistMenu(show) {
            this.showShortlistMenu = show;
        }
    },
};
</script>
